
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5774',
  depVersions: {
  "data-privacy-request-ui": "static-1.5774",
  "client-types": "static-1.493",
  "data-fetching-client": "static-1.9913",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8283",
  "hub-http-shared-msw-handlers": "static-1.10541",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11739",
  "I18n": "static-7.1664",
  "jasmine-runner": "static-1.6705",
  "quartz": "static-1.7390",
  "react-dlb": "static-1.85",
  "rpc-client-utils": "static-1.4919",
  "ui-components-test-utils": "static-1.5876",
  "UIComponents": "static-3.8685",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.90",
  "foundations-assets": "static-1.5139",
  "foundations-components": "static-1-ech-accordiontransition-jank.10",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.10",
  "foundations-theming": "static-1.4722",
  "hub-http": "static-1.6469",
  "quartz-config": "static-1.1168",
  "quartz-core": "static-1.6609",
  "quartz-routing": "static-1.820",
  "quick-fetch": "static-1.4101",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-rhumb": "static-1.16968",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11400",
  "usage-tracker": "static-1.7613",
  "usage-tracker-anonymous": "static-1.6030",
  "usage-tracker-core": "static-1.7463",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3586",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3667",
  "quartz-webpack": "static-1.3614",
  "bend-plugin-quartz-routing": "static-1.468",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3394",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "ts-schema": "static-1.4263",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "react-utils": "static-2.5523",
  "StyleGuideUI": "static-3.496",
  "jasmine": "static-4.4573",
  "bend-plugin-chirp-manifest": "static-1.329",
  "chirp-fetch": "static-1.2150",
  "HubStyle": "static-2.12046",
  "ui-addon-draggable": "static-3.5011",
  "cssUtils": "static-1.874",
  "hs-story-utils": "static-1.9683",
  "icons": "static-2.675",
  "react-create-root-preference": "static-1.63",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1232",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.10",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2438",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2506",
  "ui-fonts": "static-1.1001",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.10",
  "bend-plugin-foundations-theming": "static-1.3205",
  "foundations-theming-base": "static-1.3707",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.262",
  "opentelemetry-fe-types": "static-1.27",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4832",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.402",
  "quartz-auth": "static-1.1065",
  "quartz-head": "static-1.1055",
  "quartz-i18n": "static-1.1065",
  "quartz-test": "static-1.1065",
  "quartz-tracking": "static-1.769",
  "trellis-components": "static-1.2525",
  "usage-tracker-container": "static-1.7603",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3382",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.75",
  "sassPrefix": "static-1.162",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10539",
  "usage-tracker-session-replay": "static-1.5299",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1223",
  "tanstack-virtual": "static-1.36",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5774",
  "client-types": "/client-types/static-1.493",
  "data-fetching-client": "/data-fetching-client/static-1.9913",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8283",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10541",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11739",
  "I18n": "/I18n/static-7.1664",
  "jasmine-runner": "/jasmine-runner/static-1.6705",
  "quartz": "/quartz/static-1.7390",
  "react-dlb": "/react-dlb/static-1.85",
  "rpc-client-utils": "/rpc-client-utils/static-1.4919",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5876",
  "UIComponents": "/UIComponents/static-3.8685",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "foundations-assets": "/foundations-assets/static-1.5139",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.10",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.10",
  "foundations-theming": "/foundations-theming/static-1.4722",
  "hub-http": "/hub-http/static-1.6469",
  "quartz-config": "/quartz-config/static-1.1168",
  "quartz-core": "/quartz-core/static-1.6609",
  "quartz-routing": "/quartz-routing/static-1.820",
  "quick-fetch": "/quick-fetch/static-1.4101",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-rhumb": "/react-rhumb/static-1.16968",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11400",
  "usage-tracker": "/usage-tracker/static-1.7613",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6030",
  "usage-tracker-core": "/usage-tracker-core/static-1.7463",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3586",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3667",
  "quartz-webpack": "/quartz-webpack/static-1.3614",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.468",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3394",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "ts-schema": "/ts-schema/static-1.4263",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "react-utils": "/react-utils/static-2.5523",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "jasmine": "/jasmine/static-4.4573",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.329",
  "chirp-fetch": "/chirp-fetch/static-1.2150",
  "HubStyle": "/HubStyle/static-2.12046",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5011",
  "cssUtils": "/cssUtils/static-1.874",
  "hs-story-utils": "/hs-story-utils/static-1.9683",
  "icons": "/icons/static-2.675",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1232",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.10",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2438",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2506",
  "ui-fonts": "/ui-fonts/static-1.1001",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.10",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3205",
  "foundations-theming-base": "/foundations-theming-base/static-1.3707",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.262",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.27",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4832",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.402",
  "quartz-auth": "/quartz-auth/static-1.1065",
  "quartz-head": "/quartz-head/static-1.1055",
  "quartz-i18n": "/quartz-i18n/static-1.1065",
  "quartz-test": "/quartz-test/static-1.1065",
  "quartz-tracking": "/quartz-tracking/static-1.769",
  "trellis-components": "/trellis-components/static-1.2525",
  "usage-tracker-container": "/usage-tracker-container/static-1.7603",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.75",
  "sassPrefix": "/sassPrefix/static-1.162",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10539",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5299",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1223",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
